export default class ErrorHelper {
    /**
     * Composes an error message from the API response
     * @param {string} actionDescription - What were you trying to do when the request failed?
     * @param {any} response - The response for the failed request
     */
    public static composeErrorMessage(actionDescription: string, response: any) {
        if (response.status === 500) {
            return `Could not ${actionDescription}.`;
        }
        return `Could not ${actionDescription}: ${ErrorHelper.getErrorSummary(response)}`;
    }

    public static getErrorSummary(response: any) {
        if (response && response.data && response.data.message) {
        return response.data.message;
        }
    }
}
